import "./index.scss";
import { VideoPreviewImageProps } from "./types";
import React, { useEffect, useRef } from "react";
import VideoCta from "../VideoCta";

const VideoPreviewImage = ({
  playVideo,
  previewImage,
  showCta = true,
  showPreviewImage = true,
}: VideoPreviewImageProps) => {
  const previewImageRef = useRef<HTMLDivElement>(null);
  const style = previewImage
    ? {
        backgroundImage: `url(${previewImage})`,
      }
    : {};
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (showPreviewImage) {
      if (previewImageRef?.current) {
        previewImageRef.current.style.display = "block";
      }
      timeout = setTimeout(() => {
        if (previewImageRef?.current) {
          previewImageRef.current.classList.add("VideoPreviewImage__show");
        }
      }, 300);
    } else {
      if (previewImageRef?.current) {
        previewImageRef.current.classList.remove("VideoPreviewImage__show");
      }
      timeout = setTimeout(() => {
        if (previewImageRef?.current) {
          previewImageRef.current.style.display = "none";
        }
      }, 300);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [showPreviewImage]);
  return (
    <div
      className="VideoPreviewImage VideoPreviewImage__show"
      style={style}
      ref={previewImageRef}
    >
      <VideoCta playVideo={playVideo} showCta={showCta} />
    </div>
  );
};

export default VideoPreviewImage;
